webpackJsonp([81389953792429],{

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BeansPage = function BeansPage() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Picking Our Beans'
	      )
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Picking Our Beans'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Choosing the right beans is one of the most important steps to creating the perfect blend of coffee. Coffee beans are seeds of the plants of genus',
	      ' ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'Coffea'
	      ),
	      ' and family Rubiaceae. There are many different species classified under ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'Coffea'
	      ),
	      ' but only two of them are widely used to grow coffee beans: ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'Coffea arabica'
	      ),
	      ', and ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'Coffea canephora'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We have found that the most important factor differentiating different varieties of beans is the location where the plant was grown. We require our beans to be grown under very specific circumstances. The plant must be grown near the equator. It must be grown on a mountain that is about six to eight thousand feet tall, at an elevation of about three to four thousand feet high, on the western face of the mountain. The mountain must also be near the ocean on both its western and eastern sides.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The soil coffee plants are grown on must be taken into consideration. It must be fertile and have an appropriate pH level. Even other kinds of plants grown nearby contribute heavily to the quality of the beans and our considerations.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If any of our requirements are not met, the resultant coffee will be too sour, bitter, or tasteless. These conditions make it possible for the perfect coffee beans to be grown, in turn enabling us to brew coffee that fits our standards.'
	    )
	  );
	};
	
	exports.default = BeansPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-beans-js-75497563924a325e5564.js